var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactDetails = function SvgContactDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.667 14.5v5.072A2.43 2.43 0 0 1 10.238 22H4.43A2.43 2.43 0 0 1 2 19.572V5.762a2.43 2.43 0 0 1 2.43-2.428h2.237M2 18h10.667M19.474 2h-6.948A2.526 2.526 0 0 0 10 4.526v3.79a2.526 2.526 0 0 0 2.526 2.526h3.158V14l3.158-3.158h.632A2.526 2.526 0 0 0 22 8.316v-3.79A2.526 2.526 0 0 0 19.474 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 6h.01M13 6h.01M19 6h.01"
  })));
};
export default SvgContactDetails;